import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-insta',
    templateUrl: './insta.component.html',
    styleUrls: ['./insta.component.scss'],
    standalone: false
})
export class InstaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
  

}
